import styled from 'styled-components'
import { H1 } from '../../../../styles/typography'
import { center } from '../../../../styles/style-helpers'
import { accent } from '../../../../styles/colors'

export const RegModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  max-height: 100%;
  margin-bottom: 2rem;
  overflow: scroll;
  .RegModalHeading {
    font-size: 1.5em;
    width: 100%;
  }
  .PaymentType {
    padding: 10px;
    width: 100%;
    transition: 'all 0.3s ease';
    .PaymentHeading {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      h4 {
        color: #000;
        fontweight: 900;
      }
    }

    p {
      line-height: 1.33;
      color: #444;
      > span {
        color: ${accent};
      }
    }
    > div > span {
      color: ${accent};
    }

    button {
      width: 100%;
      font-weight: bold;
      margin-top: 1em;
      font-size: 1.125em;
    }

    ul {
      margin-top: 1em;
      padding-left: 1.5em;
      color: #444;

      li {
        margin: 0.5em 0;
        color: #666;
      }
    }
    .fee {
      opacity: ${({ hideFee }) => (hideFee ? 0 : 1)};

      p {
        width: fit-content;
        position: relative;
        color: #000;
        margin-left: auto;
        margin-right: 0;

        &:after {
          content: '';
          ${center};
          width: 100%;
          height: 1px;
          background: #000;
        }
      }

      h4 {
        color: #000;
        font-size: 1.3em;
        span {
          margin-right: 0.5em;
          font-size: 0.54em;
          letter-spacing: 0.025em;
          color: #000;
        }
      }
    }
  }
`
